import { Link } from "react-router-dom";

const Nav = () => {
    return(
      <nav className="min-width grey darken-4" role="navigation">
        <div className="row" style={{"width": "80%"}}>
          <Link to="/" className="col s3 brand-logo right blue-grey-text text-lighten-5 titlesec" id="logo-container">
                <div>
                  <img src="https://web.phys.ntu.edu.tw/string/pic/icon-ani.gif" alt="Icon" width="70" height="70" />
                  <span className="title-name">
                    NTU Strings
                  </span>
                </div>
                
          </Link>
          <div className="col s9 push-s2">
            <ul className="right">
              <li>
                <Link to="/members" className="tab-title">
                  Members
                </Link>
              </li>
              <li>
                <Link to="/whatwedo" className="tab-title">
                  Prospective Members
                </Link>
              </li>
              <li>
                <Link to="/visit" className="tab-title">
                  To Visitors
                </Link>
              </li>
              <li>
                <Link to="/events" className="tab-title">
                  News & Events
                </Link>
              </li>
              <li>
                <Link to="/links" className="tab-title">
                  Links
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    )
}

export default Nav;